import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Products from './Products';
import TrayModule from '../TrayModule';
import Categories from '../Categories';
import TrayToolbar from '../TrayToolbar';
import { sliceHasCategories, getSliceColourTheme } from '../../selectors';
import { sliceColourTheme } from '../../styles/theme';
import { colourThemeType } from '../../propTypes';

const CategorizedTray = ({
  className, sliceId, hasCategories, colourTheme,
}) => (
  <TrayModule className={className} sliceId={sliceId} colourTheme={colourTheme}>
    <TrayToolbar sliceId={sliceId} colourTheme={colourTheme}>
      {hasCategories && <Categories sliceId={sliceId} />}
    </TrayToolbar>
    <Products sliceId={sliceId} colourTheme={colourTheme} />
  </TrayModule>
);

CategorizedTray.propTypes = {
  className: PropTypes.string,
  sliceId: PropTypes.number.isRequired,
  hasCategories: PropTypes.bool,
  colourTheme: colourThemeType,
};

CategorizedTray.defaultProps = {
  className: undefined,
  hasCategories: false,
  colourTheme: sliceColourTheme.white,
};

const mapStateToProps = (state, { sliceId }) => ({
  hasCategories: sliceHasCategories(state, sliceId),
  colourTheme: sliceColourTheme[getSliceColourTheme(state, sliceId)],
});

export default connect(mapStateToProps)(CategorizedTray);
